import { __decorate } from "tslib";
import { FrontendFeaturePlugin, provideRootRoutes } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import { StatisticsDashboardComponent } from './statistics-dashboard.component';
import * as i0 from "@angular/core";
let StatisticsFrontendAdminFeature = /*#__PURE__*/(() => {
  let StatisticsFrontendAdminFeature = class StatisticsFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/statistics/frontend-admin","featureId":"common-statistics"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        adminToolbar: [{
          label: 'Statistik',
          icon: 'chart-bar',
          routerLink: 'statistics',
          priority: 0,
          declareGroup: 'statistics'
        }]
      });
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵStatisticsFrontendAdminFeature_BaseFactory;
        return function StatisticsFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵStatisticsFrontendAdminFeature_BaseFactory || (ɵStatisticsFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(StatisticsFrontendAdminFeature)))(__ngFactoryType__ || StatisticsFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: StatisticsFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'statistics',
          defineAddonSlot: 'statistics',
          children: [{
            path: '',
            pathMatch: 'full',
            component: StatisticsDashboardComponent
          }]
        }])]
      });
    }
  };
  StatisticsFrontendAdminFeature = __decorate([ClassName("StatisticsFrontendAdminFeature")], StatisticsFrontendAdminFeature);
  return StatisticsFrontendAdminFeature;
})();
export { StatisticsFrontendAdminFeature };